var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',_vm._l((_vm.colors),function(color){return _c('tr',[_c('td',{class:("bd-color has-background-" + color)}),_c('td',[_vm._v(" "+_vm._s(color)+" ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }